module.exports = __webpack_public_path__ + "images/application/i-sys-status-bc6daa28.svg";